import type { CryptoAddressCheckResponse } from '../model';

export const isCryptoAddressValid = (
  result: CryptoAddressCheckResponse['result']
) => result !== 'invalid';
